<div *ngIf="!easGroup.meta?.hidden">
  <ng-container *ngIf="beforeTemplate">
    <ng-container *ngTemplateOutlet="beforeTemplate; context: {$implicit: easGroup}"></ng-container>
  </ng-container>
  <ng-container *ngIf="mainTemplate">
    <ng-container *ngTemplateOutlet="mainTemplate; context: {$implicit: easGroup}"></ng-container>
  </ng-container>
  <ng-container *ngIf="!mainTemplate">
    <div *ngFor="let control of easGroup.controls">
      <eas-easform-element [easElement]="control"
                           [templates]="templates"
                           [forceDisplayReadOnly]="forceDisplayReadOnly"></eas-easform-element>
    </div>
  </ng-container>
  <ng-container *ngIf="afterTemplate">
    <ng-container *ngTemplateOutlet="afterTemplate; context: {$implicit: easGroup}"></ng-container>
  </ng-container>
 </div>